export default __webpack_public_path__ + "static/media/MaduroChurchillOpen.f17bda05.jpg";